/** What an extractor holds, as a bar across: a segment per unit when they fit, filling as it stores. */
import type { CSSProperties, JSX, ReactNode } from 'react';

import { t } from '@i18n/index';

/** More units than this and the bar is one smooth fill. */
const MOST_SEGMENTS = 30;

export function HoldsBar({
  stored,
  storage,
  resource,
  children,
}: {
  stored: number;
  storage: number;
  resource: string;
  /** Under the bar: more about what it holds. */
  children?: ReactNode;
}): JSX.Element {
  const fill = storage > 0 ? Math.min(1, stored / storage) : 0;
  const segments = storage <= MOST_SEGMENTS ? storage : 0;
  return (
    <div className="holds" data-stat="holds">
      <div className="stat-head">
        <span className="k">{t('info.holds')}</span>
        <b>
          {stored}
          <small>/{storage}</small>
        </b>
        <small>{resource}</small>
      </div>
      <div
        className={`holds-bar${fill >= 1 ? ' full' : ''}`}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={storage}
        aria-valuenow={stored}
        aria-label={`${t('info.holds')} ${String(stored)}/${String(storage)} ${resource}`}
        style={{ '--segments': segments } as CSSProperties}
      >
        <i className="fill" style={{ width: `${(fill * 100).toFixed(1)}%` }} />
        {segments > 0 && <i className="segments" />}
      </div>
      {children}
    </div>
  );
}
